import { useEffect, useState } from 'react';
	 
export function useDebounceValue<T>(value: T, delay = 500) {
const [debouncedValue, setDebouncedValue] = useState<T>();

useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay);

    return () => clearTimeout(timer);
}, [value, delay]);

return debouncedValue;
}
 
 export default useDebounceValue;